/* eslint-disable class-methods-use-this */
import React, { useState } from "react";

import PageWrapper from "Components/Pages/Wrapper";

import { Box } from "styles/globalComponents";
import { createToast } from "Utils/toastFunc";
import { forgotPasswordAPI } from "Requests/Auth";
import { Loader } from "Components/Loader";
import { Button } from "Components/Button";

export const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    try {
      setLoading(true);
      const response = await forgotPasswordAPI(email);
      createToast("success", "Email enviado com sucesso");
    } catch (error) {
      createToast(
        "error",
        "Não foi possível enviar o email para recuperar os dados"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper className="">
      <div className="container">
        <div className="app-auth-panel">
          <div className="panel-header">
            <h3 className="text-purple text-no-margin">Recuperar senha</h3>
          </div>
          <form onSubmit={handleSubmit} method="POST" className="panel-content">
            <div className="row">
              <Box className="xs-12" mb="10">
                <label htmlFor="email">Email</label>
                <input
                  placeholder="email@exemplo.com.br"
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="input"
                />
              </Box>

              <div className="xs-12">
                <Box mt="5" display="flex" justify="center">
                  <Button
                    type="submit"
                    borderRadius="9"
                    padding="10px 50px"
                    disabled={loading}
                    classButton="button bt"
                  >
                    {loading ? <Loader size={20} /> : "Enviar"}
                  </Button>
                </Box>
              </div>
            </div>
          </form>
        </div>
      </div>
    </PageWrapper>
  );
};

export default ForgotPassword;
